module.exports = __webpack_public_path__ + "static/media/info.f4bd59f1.svg";